import { render, staticRenderFns } from "./send-remind-form.vue?vue&type=template&id=1fefe26a"
import script from "./send-remind-form.vue?vue&type=script&lang=js"
export * from "./send-remind-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports